// import components
import Kbd from 'components/shared/Typography/Kbd/Kbd';

// import styles
import {
  StyledShortcutsRowListItemText,
  StyledShortcutsRowListItemIcon,
  StyledShortcutsRowListItem
} from './ShortcutsRow.styles';

// import types
import { ShortcutsRowProps } from './ShortcutsRow.types';

const ShortcutsRow = ({ primary, secondary, keys }: ShortcutsRowProps) => {
  return (
    <StyledShortcutsRowListItem>
      <StyledShortcutsRowListItemText primary={primary} secondary={secondary} />
      <StyledShortcutsRowListItemIcon>
        <Kbd keys={keys} />
      </StyledShortcutsRowListItemIcon>
    </StyledShortcutsRowListItem>
  );
};

export default ShortcutsRow;
